module.exports = function() {
  return new Worker(__webpack_public_path__ + "8589d88dc64967844ac5.worker.js");
};